import cx from 'classnames';

import { useConfigContext } from 'lib/core/config';
import { ValueOf } from 'lib/core/types';

import Loader from 'lib/common/components/Loader';
import Modal from 'lib/common/components/Modal';
import Text from 'lib/common/components/Text';

import SIGN_OUT_TYPES from '../../constants/signOutTypes';

import './signing-out-overlay.scss';

interface ISigningOutOverlay {
  type: ValueOf<typeof SIGN_OUT_TYPES>;
}

function Content({ content, showHelp }: { content: string; showHelp: boolean }) {
  if (content && !showHelp) {
    return <Text>{content}</Text>;
  }

  return (
    <Text>
      {content || ''} Keep seeing this? Try manually{' '}
      <Text type="link" href={window.location.origin}>
        reloading the page
      </Text>
      .
    </Text>
  );
}

export default function SigningOutOverlay({ type }: ISigningOutOverlay) {
  const { config } = useConfigContext();

  const SIGN_OUT_PROPS = {
    [SIGN_OUT_TYPES.MANUAL_SIGN_OUT]: {
      showHelp: false,
      title: "We're Signing You Out",
      subtitle: "It'll only take a few seconds.",
      content: '',
    },
    [SIGN_OUT_TYPES.AUTH_FAIL]: {
      showHelp: true,
      title: 'Your Session Has Expired',
      subtitle: "We'll get you to sign in again.",
      content: `We recommend logging out or closing ${config.BRAND.productName} whenever you're finished for the day.`,
    },
  };

  const { title, content, showHelp, subtitle } = SIGN_OUT_PROPS[type];

  return (
    <Modal open title={title} subtitle={subtitle} hideFooter hideClose>
      {content && <Content showHelp={showHelp} content={content} />}
      <Loader centered className={cx({ 'mt-30': !content, 'mt-60': content }, 'mb-60')} />
    </Modal>
  );
}
